export default __webpack_public_path__ + "static/media/goFurtherImg.349acb3d.webp";